module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":{"downloadXForm":"Download XML"},"format":{"xForm":"As XForm","xlsForm":"As XLSForm"}}}')
  delete Component.options._Ctor
}
